import { render } from "./v-subscribe-form.vue?vue&type=template&id=0df5e998"
import script from "./v-subscribe-form.vue?vue&type=script&lang=js"
export * from "./v-subscribe-form.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/datadrivet/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__